import { use } from 'react'
import { format } from 'date-fns'
import { DeliveredCultivar } from '@/api-client/data-contracts'

type Props = {
  deliveredCultivars: Promise<{ data: DeliveredCultivar[] }>
}

export const DeliveredRosesSection: React.FC<Props> = ({ deliveredCultivars }) => {
  const { data: cultivars } = use(deliveredCultivars)

  if (cultivars.length === 0) return null

  const shippedOn = (cultivar: DeliveredCultivar) => {
    return format(new Date(1000 * cultivar.attributes.last_shipped_at), 'yyyy.M.d')
  }

  return (
    <section className="bg-bg pt-6 pb-14 flex flex-col gap-8">
      <h2 className="text-[24px] font-bold text-black text-center px-6">最近セレクトした品種</h2>
      <div className="flex gap-5 items-stretch overflow-x-auto px-6 pb-2 scrollbar-none">
        {cultivars.map((cultivar) => (
          <article key={cultivar.id} className="bg-white rounded-2xl overflow-hidden shrink-0 w-61 shadow-[0_8px_16px_rgba(197,197,197,0.05)]">
            {cultivar.attributes.image_url && (
              <img src={cultivar.attributes.image_url} alt={cultivar.attributes.name} className="w-full aspect-220/252 object-cover" />
            )}
            <div className="p-4 flex flex-col gap-3">
              <h3 className="text-[16px] font-bold text-black truncate">{cultivar.attributes.name}</h3>
              {cultivar.attributes.description && <p className="text-[12px] leading-[1.6] text-[#4b5563]">{cultivar.attributes.description}</p>}
              {shippedOn(cultivar) && <p className="text-[13px] font-semibold text-dark-gray">{shippedOn(cultivar)} 発送</p>}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
